/**
 * Intestatario del conto (campi SDD_*) copiato dai dati anagrafici della pratica, per il tasto
 * "Copia dai dati cliente" della sezione Pagamento. Privato: nome, cognome e codice fiscale del cliente.
 * Azienda: il firmatario è il legale rappresentante se indicato (prima parola = nome), altrimenti la ragione
 * sociale va nel cognome; il codice fiscale si copia solo se è di una persona (Ermes rifiuta la partita IVA come
 * codice fiscale del firmatario: al caricamento il CRM mette quello del rappresentante legale della scheda cliente).
 * Si copiano solo i valori presenti: i campi del conto già scritti non si svuotano.
 */
import { cfNamesCheck, splitNameByCf } from './codiceFiscale'

export const SDD_HOLDER_KEYS = ['SDD_NOME_FIRMATARIO', 'SDD_COGNOME_FIRMATARIO', 'SDD_CF_FIRMATARIO'] as const

/** Codice fiscale di una persona fisica (16 caratteri, anche con le lettere dell'omocodia), non una partita IVA. */
export const isPersonFiscalCode = (s: string | undefined): boolean =>
  /^[A-Z]{6}[A-Z0-9]{2}[A-Z][A-Z0-9]{2}[A-Z][A-Z0-9]{3}[A-Z]$/i.test(String(s ?? '').trim())

export function sddHolderFromCustomer(values: Record<string, string | undefined>, tipo: string): Record<string, string> {
  const t = (k: string) => String(values[k] ?? '').trim()
  const out: Record<string, string> = {}
  const put = (k: string, v: string) => { if (v) out[k] = v }
  if (tipo === 'AZIENDA') {
    // 30/10/2026: il rappresentante legale arriva dalla visura come «Cognome Nome»; se c'è un codice fiscale di persona
    // (del firmatario già scritto, o del cliente) decide lui qual è il nome; altrimenti prima parola = nome, come prima.
    const cfPersona = [t('SDD_CF_FIRMATARIO'), t('CODICE_FISCALE_CLIENTE')].find(isPersonFiscalCode)
    const { nome, cognome } = splitNameByCf(t('LEGALE_RAPPRESENTANTE_CLIENTE'), cfPersona)
    if (nome) {
      put('SDD_NOME_FIRMATARIO', nome)
      put('SDD_COGNOME_FIRMATARIO', cognome)
    } else {
      put('SDD_COGNOME_FIRMATARIO', t('RAGIONE_SOCIALE_CLIENTE'))
    }
    if (isPersonFiscalCode(t('CODICE_FISCALE_CLIENTE'))) put('SDD_CF_FIRMATARIO', t('CODICE_FISCALE_CLIENTE').toUpperCase())
    return out
  }
  // privato: nome e cognome del cliente, nell'ordine che dice il suo codice fiscale (se risultano invertiti)
  const invertiti = cfNamesCheck(t('CODICE_FISCALE_CLIENTE'), t('NOME_CLIENTE'), t('COGNOME_CLIENTE')) === 'swapped'
  put('SDD_NOME_FIRMATARIO', invertiti ? t('COGNOME_CLIENTE') : t('NOME_CLIENTE'))
  put('SDD_COGNOME_FIRMATARIO', invertiti ? t('NOME_CLIENTE') : t('COGNOME_CLIENTE'))
  put('SDD_CF_FIRMATARIO', t('CODICE_FISCALE_CLIENTE').toUpperCase())
  return out
}
